import { SET_PURCHASEOFFERS, SET_PURCHASEOFFERS_STOCK } from '@/store/mutationTypes';
import purchaseOfferApi from 'src/api/server/purchaseOffers';
import ApiLoadingStatus from '@/api/statusTypes';
import { FAILED, LOADED, LOADING, CHANGE_STATE, SET_STATUS, SET_PURCHASEOFFER_ERROR } from '../mutationTypes';
import { LOAD, RELOAD, PURCHASEOFFERS } from '../actionTypes';
import PURCHASEOFFER from 'Constants/purchaseOffer';
import STATES from 'src/constants/storeObjects';
import { GET_ALL, GET_PURCHASEOFFER_FOR_DEMAND_FILTERED } from '../getterTypes';

export default {
  namespaced: true,
  state: {
    all: [],
    notStock: [],
    stock: [],
    errors: [],
    lastUpdate: null,
    status: ApiLoadingStatus.STATUS_NOT_INITIALIZED,
    statusPurchaseOffers: ApiLoadingStatus.STATUS_NOT_INITIALIZED,
    statusPurchaseOffersStock: ApiLoadingStatus.STATUS_NOT_INITIALIZED,
  },
  mutations: {
    [SET_PURCHASEOFFERS](state, payload) {
      state.notStock = payload.purchaseOffers.map((item) => ({
        ...item,
        _showDetails: false,
        _status: STATES.STATE.IDLE,
        _stock: false,
        _error: null,
      }));
      if (null === state.lastUpdate || payload.lastUpdate > state.lastUpdate) state.lastUpdate = payload.lastUpdate;
    },
    [SET_PURCHASEOFFERS_STOCK](state, payload) {
      state.stock = payload.purchaseOffers.map((item) => ({
        ...item,
        _showDetails: false,
        _status: STATES.STATE.IDLE,
        _efg: item.userEmail === 'efg@chronext.com',
        _stock: true,
        _error: null,
      }));
      if (null === state.lastUpdate || payload.lastUpdate > state.lastUpdate) state.lastUpdate = payload.lastUpdate;
    },
    [LOADING](state) {
      state.status = ApiLoadingStatus.STATUS_LOADING;
    },
    [FAILED](state) {
      state.status = ApiLoadingStatus.STATUS_ERROR_LOADING;
    },
    [LOADED](state) {
      state.status = ApiLoadingStatus.STATUS_SUCCESSFUL;
    },
    [SET_STATUS](state, payload) {
      const indexStock = state.stock.findIndex((item) => item.purchaseOfferId === payload.purchaseOfferId);
      if (indexStock !== -1) {
        state.stock[indexStock]._status = payload.status;
      }
      const index = state.notStock.findIndex((item) => item.purchaseOfferId === payload.purchaseOfferId);
      if (index !== -1) {
        state.notStock[index]._status = payload.status;
      }
    },
    [CHANGE_STATE](state, payload) {
      const indexStock = state.stock.findIndex((item) => item.purchaseOfferId === payload.purchaseOfferId);
      if (indexStock !== -1) {
        state.stock[indexStock].state = payload.state;
        state.stock[indexStock].demandId = payload.demandId;
      }
      const index = state.notStock.findIndex((item) => item.purchaseOfferId === payload.purchaseOfferId);
      if (index !== -1) {
        state.notStock[index].state = payload.state;
        state.notStock[index].demandId = payload.demandId;
      }
    },
    ['ADD_ERROR'](state, payload) {
      state.errors.push(payload.error);
    },
    [SET_PURCHASEOFFER_ERROR](state, payload) {
      const indexStock = state.stock.findIndex((item) => item.purchaseOfferId === payload.purchaseOfferId);
      if (indexStock !== -1) {
        state.stock[indexStock]._status = STATES.STATE.IDLE;
        state.stock[indexStock]._error = payload.error;
      }
      const index = state.notStock.findIndex((item) => item.purchaseOfferId === payload.purchaseOfferId);
      if (index !== -1) {
        state.notStock[index]._status = STATES.STATE.IDLE;
        state.notStock[index]._error = payload.error;
      }
    },
  },
  actions: {
    async [RELOAD]({ commit }, { startDate, endDate, startDateStock, endDateStock }) {
      try {
        commit(LOADING);
        Promise.all([
          purchaseOfferApi.loadPurchaseOffers(startDate, endDate, false),
          purchaseOfferApi.loadPurchaseOffers(startDateStock, endDateStock, true),
        ]).then((values) => {
          commit(SET_PURCHASEOFFERS, values[0]);
          commit(SET_PURCHASEOFFERS_STOCK, values[1]);
          commit(LOADED);
        });
      } catch (e) {
        commit(FAILED);
      }
    },
    async [LOAD]({ dispatch, state }, { startDate, endDate, startDateStock, endDateStock }) {
      if (state.status === ApiLoadingStatus.STATUS_SUCCESSFUL) {
        return;
      }
      return dispatch(RELOAD, {
        startDate,
        endDate,
        startDateStock,
        endDateStock,
      });
    },
    async [PURCHASEOFFERS.CREATE](
      { commit },
      { comment, variantKey, productKey, demandId, watchesToAccessDate, watchesOnStock, watchesToAccess, userEmail },
    ) {
      try {
        await purchaseOfferApi.createPurchaseOffer({
          comment: comment,
          variantKey: variantKey,
          productKey: productKey,
          demandId: demandId,
          watchesToAccessDate: watchesToAccessDate,
          watchesOnStock: watchesOnStock,
          watchesToAccess: watchesToAccess,
          userEmail: userEmail,
        });
      } catch (e) {
        commit('ADD_ERROR', e);
      }
    },
    async [PURCHASEOFFERS.BLOCK]({ commit }, { purchaseOfferId, demandId, userId }) {
      try {
        commit(SET_PURCHASEOFFER_ERROR, {
          purchaseOfferId: purchaseOfferId,
          error: null,
        });
        commit(SET_STATUS, {
          purchaseOfferId: purchaseOfferId,
          status: STATES.STATE.BUSY,
        });

        await purchaseOfferApi.blockPurchaseOffer(purchaseOfferId, demandId);
        commit(CHANGE_STATE, {
          state: PURCHASEOFFER.STATE.REQUESTED,
          purchaseOfferId: purchaseOfferId,
          demandId: demandId,
          userId: userId,
        });
        commit(
          'demands/REQUEST_DEMAND',
          {
            demandId: demandId,
            purchaseOfferId: purchaseOfferId,
          },
          { root: true },
        );
        commit(SET_STATUS, {
          purchaseOfferId: purchaseOfferId,
          status: STATES.STATE.IDLE,
        });
      } catch (e) {
        commit(SET_PURCHASEOFFER_ERROR, {
          purchaseOfferId: purchaseOfferId,
          error: e.response.data.errors[0],
        });
      }
    },
    async [PURCHASEOFFERS.UNBLOCK]({ commit }, { purchaseOfferId, demandId }) {
      try {
        commit(SET_STATUS, {
          purchaseOfferId: purchaseOfferId,
          status: STATES.STATE.BUSY,
        });
        await purchaseOfferApi.unblockPurchaseOffer(purchaseOfferId);
        commit(CHANGE_STATE, {
          state: PURCHASEOFFER.STATE.OPEN,
          purchaseOfferId: purchaseOfferId,
          demandId: null,
          userId: null,
        });
        commit(
          'demands/UNREQUEST_DEMAND',
          {
            demandId: demandId,
            purchaseOfferId: purchaseOfferId,
          },
          { root: true },
        );
        commit(SET_STATUS, {
          purchaseOfferId: purchaseOfferId,
          status: STATES.STATE.IDLE,
        });
      } catch (e) {
        commit(SET_PURCHASEOFFER_ERROR, {
          purchaseOfferId: purchaseOfferId,
          error_title: 'Failed to unrequest purchase offer',
          error_msg: e,
        });
      }
    },
    async [PURCHASEOFFERS.REJECT]({ commit }, { purchaseOfferId }) {
      try {
        commit(SET_STATUS, {
          purchaseOfferId: purchaseOfferId,
          status: STATES.STATE.BUSY,
        });
        await purchaseOfferApi.rejectPurchaseOffer(purchaseOfferId);
        commit(CHANGE_STATE, {
          state: PURCHASEOFFER.STATE.REJECTED,
          purchaseOfferId: purchaseOfferId,
          demandId: null,
          userId: null,
        });
        commit(SET_STATUS, {
          purchaseOfferId: purchaseOfferId,
          status: STATES.STATE.IDLE,
        });
      } catch (e) {
        commit(SET_PURCHASEOFFER_ERROR, {
          purchaseOfferId: purchaseOfferId,
          error_title: 'Failed to reject purchase offer',
          error_msg: e,
        });
      }
    },
    async [PURCHASEOFFERS.FAIL]({ commit }, { purchaseOfferId }) {
      try {
        commit(SET_STATUS, {
          purchaseOfferId: purchaseOfferId,
          status: STATES.STATE.BUSY,
        });
        await purchaseOfferApi.failPurchaseOffer({
          purchaseOfferId: purchaseOfferId,
        });
        commit(CHANGE_STATE, {
          state: PURCHASEOFFER.STATE.FAILED,
          purchaseOfferId: purchaseOfferId,
          demandId: null,
          userId: null,
        });
        commit(SET_STATUS, {
          purchaseOfferId: purchaseOfferId,
          status: STATES.STATE.IDLE,
        });
      } catch (e) {
        commit(SET_PURCHASEOFFER_ERROR, {
          purchaseOfferId: purchaseOfferId,
          error_title: 'Failed to fail purchase offer',
          error_msg: e,
        });
      }
    },
  },
  getters: {
    [GET_ALL]: (state) => {
      return state.stock.concat(state.notStock);
    },
    [GET_PURCHASEOFFER_FOR_DEMAND_FILTERED]: (state) => (
      productKey,
      variantKey,
      demandId,
      merchantEmail,
      type,
      user,
    ) => {
      return state.stock
        .concat(state.notStock)
        .filter((purchaseOffer) => {
          return productKey === purchaseOffer.productKey && variantKey === purchaseOffer.variantKey;
        })
        .filter((purchaseOffer) => {
          if (purchaseOffer._stock && PURCHASEOFFER.TYPE.MANUAL === type) {
            return false;
          }
          if (!purchaseOffer._stock && PURCHASEOFFER.TYPE.AUTOMATIC === type) {
            return false;
          }
          return true;
        })
        .filter((purchaseOffer) => {
          if (undefined !== merchantEmail && 0 !== merchantEmail.length) {
            return purchaseOffer.userEmail.toLowerCase().indexOf(merchantEmail.toLowerCase()) !== -1;
          }
          return true;
        })
        .filter((purchaseOffer) => {
          if (
            PURCHASEOFFER.STATE.OPEN === purchaseOffer.state &&
            (null === purchaseOffer.demandId || undefined === purchaseOffer.demandId)
          ) {
            return true;
          } else if (PURCHASEOFFER.STATE.REQUESTED === purchaseOffer.state && demandId === purchaseOffer.demandId) {
            return true;
          }
          return false;
        })
        .filter((purchaseOffer) => {
          if (user === null) return true;
          if (purchaseOffer.state === PURCHASEOFFER.STATE.REQUESTED && purchaseOffer.lastUpdatedByUserId === user.id) {
            return true;
          }
          return false;
        });
    },
  },
};
